import { render, staticRenderFns } from "./ManageOrderRefund.vue?vue&type=template&id=b67167ee&scoped=true&"
import script from "./ManageOrderRefund.vue?vue&type=script&lang=js&"
export * from "./ManageOrderRefund.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrderRefund.vue?vue&type=style&index=0&id=b67167ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67167ee",
  null
  
)

export default component.exports